import React from 'react';
import { ActivityIcon, MailIcon, MapPinIcon } from 'lucide-react';
const footerLinks = {
  programs: [{
    label: 'Meridian Protocol',
    href: '#'
  }, {
    label: 'Apex Convergence',
    href: '#'
  }, {
    label: 'Cipher Matrix',
    href: '#'
  }, {
    label: 'Zenith Mastery',
    href: '#'
  }],
  resources: [{
    label: 'Blog',
    href: '#'
  }, {
    label: 'Webinary',
    href: '#'
  }, {
    label: 'Słownik tradera',
    href: '#'
  }, {
    label: 'FAQ',
    href: '#'
  }],
  company: [{
    label: 'O nas',
    href: '#about'
  }, {
    label: 'Kariera',
    href: '#'
  }, {
    label: 'Kontakt',
    href: '#'
  }, {
    label: 'Partnerzy',
    href: '#'
  }],
  legal: [{
    label: 'Regulamin',
    href: '#'
  }, {
    label: 'Polityka prywatności',
    href: '#'
  }, {
    label: 'Cookies',
    href: '#'
  }]
};
export function Footer() {
  return <footer className="bg-gray-950 border-t border-gray-800" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-104">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-12" data-id="element-105">
          {/* Brand */}
          <div className="col-span-2" data-id="element-106">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-107">
              <div className="w-8 h-8 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg flex items-center justify-center" data-id="element-108">
                <ActivityIcon className="w-5 h-5 text-gray-900" data-id="element-109" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-110">
                Winrealm
              </span>
            </a>
            <p className="text-gray-500 text-sm mb-4 max-w-xs" data-id="element-111">
              Profesjonalne szkolenia z analizy technicznej i tradingu dla
              ambitnych inwestorów.
            </p>
            <div className="space-y-2 text-sm text-gray-500" data-id="element-112">
              <div className="flex items-start gap-2" data-id="element-113">
                <MapPinIcon className="w-4 h-4 mt-0.5 flex-shrink-0" data-id="element-114" />
                <span data-id="element-115">
                  QUANTUM ASSETS KRS 0000190764
                  <br data-id="element-116" />
                  ul. WALEREGO SŁAWKA 3A
                  <br data-id="element-117" />
                  30-633 KRAKÓW
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-118">
                <MailIcon className="w-4 h-4" data-id="element-119" />
                <a href="mailto:kontakt@winrealm.pl" className="hover:text-emerald-400 transition-colors" data-id="element-120">
                  kontakt@winrealm.pl
                </a>
              </div>
            </div>
          </div>

          {/* Programs */}
          <div data-id="element-121">
            <h4 className="text-white font-semibold mb-4" data-id="element-122">Programy</h4>
            <ul className="space-y-2" data-id="element-123">
              {footerLinks.programs.map(link => <li key={link.label} data-id="element-124">
                  <a href={link.href} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors" data-id="element-125">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-126">
            <h4 className="text-white font-semibold mb-4" data-id="element-127">Zasoby</h4>
            <ul className="space-y-2" data-id="element-128">
              {footerLinks.resources.map(link => <li key={link.label} data-id="element-129">
                  <a href={link.href} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors" data-id="element-130">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-131">
            <h4 className="text-white font-semibold mb-4" data-id="element-132">Firma</h4>
            <ul className="space-y-2" data-id="element-133">
              {footerLinks.company.map(link => <li key={link.label} data-id="element-134">
                  <a href={link.href} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors" data-id="element-135">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-136">
            <h4 className="text-white font-semibold mb-4" data-id="element-137">Prawne</h4>
            <ul className="space-y-2" data-id="element-138">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-139">
                  <a href={link.href} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors" data-id="element-140">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8 mb-8" data-id="element-141">
          <p className="text-xs text-gray-600 leading-relaxed" data-id="element-142">
            <strong className="text-gray-500" data-id="element-143">Ostrzeżenie o ryzyku:</strong>{' '}
            Trading i inwestowanie wiąże się z ryzykiem utraty kapitału. Wyniki
            historyczne nie gwarantują przyszłych zysków. Materiały edukacyjne
            Winrealm mają charakter informacyjny i nie stanowią rekomendacji
            inwestycyjnych. Przed podjęciem decyzji inwestycyjnych skonsultuj
            się z licencjonowanym doradcą.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-gray-800" data-id="element-144">
          <p className="text-gray-600 text-sm" data-id="element-145">
            © 2026 Winrealm. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-146">
            <a href="#" className="text-gray-600 hover:text-emerald-400 transition-colors" aria-label="Twitter" data-id="element-147">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-148">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-149" />
              </svg>
            </a>
            <a href="#" className="text-gray-600 hover:text-emerald-400 transition-colors" aria-label="YouTube" data-id="element-150">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-151">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-152" />
              </svg>
            </a>
            <a href="#" className="text-gray-600 hover:text-emerald-400 transition-colors" aria-label="LinkedIn" data-id="element-153">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-154">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-155" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}